import { useInterpret } from '@xstate/react';
import { createMachine } from 'xstate';

export function useTimeout({
  delay,
  onTimedOut,
}: {
  delay: number;
  onTimedOut: () => void;
}) {
  const service = useInterpret(() =>
    createTimeoutMachine({
      delay,
      onTimedOut,
    }),
  );

  return {
    timeout: {
      start: () => {
        service.send('start');
      },
      stop: () => {
        service.send('stop');
      },
    },
  };
}

function createTimeoutMachine({
  delay,
  onTimedOut,
}: {
  delay: number;
  onTimedOut: () => void;
}) {
  return createMachine<unknown, { type: 'start' | 'stop' }>(
    {
      id: 'timeout',
      predictableActionArguments: true,
      preserveActionOrder: true,
      initial: 'idle',
      states: {
        idle: {
          on: {
            start: 'started',
          },
        },
        started: {
          on: {
            stop: 'idle',
          },
          after: {
            [delay]: 'timed out',
          },
        },
        'timed out': {
          entry: ['on timed out'],
          type: 'final',
        },
      },
    },
    {
      actions: {
        'on timed out': onTimedOut,
      },
    },
  );
}
